import {projectCatalog} from './projectCatalogData';
export const resumeQuickEn = {
    "heroTitle": [
        "Hi, I am R0",
        "Fullstack Leadership."
    ],
    "positioning": "AI product & engineering lead. I connect product vision, technical depth, and organizational leadership — across design, fullstack systems, and algorithms.",
    "positioningHighlights": [
        "AI product & engineering lead",
        "product vision",
        "technical depth",
        "organizational leadership"
    ],
    "skillsTitle": "Skills",
    "skills": [
        "C++",
        "Modern C++",
        "STL",
        "RAII",
        "Golang",
        "Python3",
        "TypeScript",
        "JavaScript",
        "React",
        "Next.js",
        "Vue3",
        "Electron",
        "Node.js",
        "gRPC",
        "WebSocket",
        "FastAPI",
        "Django",
        "Gin",
        "Go-Zero",
        "MySQL",
        "PostgreSQL",
        "MongoDB",
        "Redis",
        "ClickHouse",
        "Elasticsearch",
        "Kafka",
        "RabbitMQ",
        "Docker",
        "Kubernetes",
        "Terraform",
        "Nginx",
        "GitHub Actions",
        "CI/CD",
        "Prometheus",
        "Grafana",
        "OpenTelemetry",
        "Scikit-learn",
        "XGBoost",
        "LightGBM",
        "CatBoost",
        "PyTorch",
        "TensorFlow",
        "Learning to Rank",
        "CTR/CVR Modeling",
        "Sequence Modeling",
        "Graph Embedding",
        "A/B Testing",
        "Causal Inference",
        "Bayesian Optimization",
        "DQN",
        "PPO",
        "MDP",
        "RAG",
        "LangChain",
        "LangGraph",
        "LlamaIndex",
        "FAISS",
        "HNSW",
        "ANN Retrieval",
        "Milvus",
        "Weaviate",
        "Pinecone",
        "OpenAI API",
        "Claude API",
        "Function Calling",
        "Agent Workflow",
        "Prompt Caching",
        "LoRA",
        "PEFT",
        "RLHF",
        "vLLM",
        "ONNX Runtime",
        "LLaMA",
        "Mistral",
        "Qwen",
        "DeepSeek",
        "OpenLLM",
        "ComfyUI",
        "Stable Diffusion",
        "ControlNet",
        "AnimateDiff",
        "NumPy",
        "Pandas",
        "Spark",
        "Flink",
        "Airflow",
        "dbt",
        "Data Governance",
        "Tag Governance",
        "Data Quality",
        "Data Lineage",
        "Feature Engineering",
        "Embedding Retrieval",
        "Multi-Armed Bandit",
        "Uplift Modeling",
        "Pairwise Ranking",
        "Listwise Ranking",
        "LambdaMART",
        "GCN",
        "GraphSAGE",
        "Word2Vec",
        "BERT Embedding",
        "Cold Start Strategy",
        "UCB/Thompson Sampling",
        "Recall@K",
        "NDCG",
        "Dynamic Programming",
        "Graph Algorithms",
        "A* Search",
        "Event Pipeline",
        "Tornado",
        "MobX",
        "Tailwind CSS",
        "RESTful API",
        "Microservices",
        "CQRS",
        "Event Sourcing",
        "JWT",
        "Rust",
        "StarRocks",
        "Paimon",
        "RAGFlow",
        "Agent Harness",
        "MCP-Agent",
        "OpenSearch",
        "Qdrant",
        "Weighted RRF",
        "BGE",
        "RoaringBitmap",
        "WAL",
        "CLIP",
        "MotionCLIP",
        "K-Means",
        "GMM",
        "Arrow",
        "Language Engineering",
        "Ontology",
        "Knowledge Compilation",
        "Context Engineering",
        "AI-SOP",
        "Noesis ADK"
    ],
    "skillHighlights": [
        "Rust",
        "Golang",
        "Python3",
        "RAG",
        "Agent Harness",
        "Flink",
        "StarRocks",
        "Kafka"
    ],
    "workTitle": "Leadership Model",
    "workCate": "The decisions I take responsibility for.",
    "aboutTitle": "About Me",
    "aboutText": "I bring intelligence, engineering, and art together to turn complex technology into human capability — helping people understand more, create freely, and act on their own ideas.",
    "aboutHighlights": [
        "human capability",
        "understand more",
        "create freely",
        "their own ideas"
    ],
    "experienceTitle": "Work & Collaboration",
    "experiences": [
        {
            "company": "Aixera",
            "period": "2026.07 – 2026.09",
            "summary": "Project Technical Lead · project collaboration; accountable for technical direction, architecture decisions, team coordination, and delivery quality.",
            "focus": [
                "Technical direction",
                "Team leadership",
                "Delivery governance"
            ],
            "progress": 100,
            "face": "(•̀ᴗ•́)و",
            "highlights": []
        },
        {
            "company": "Quanyou · OpenVision group",
            "period": "2025.08 – Present",
            "summary": "Head of AI LAB / Data Development Team Lead · collaboration; shape the AI and data portfolio, establish Agent engineering methods and delivery standards, develop teams, and own business adoption.",
            "focus": [
                "Product portfolio",
                "Architecture & engineering standards",
                "Organization & business adoption"
            ],
            "progress": 100,
            "face": "(=^･ω･^=)",
            "highlights": []
        },
        {
            "company": "Tencent IEG",
            "period": "2022.07 – 2025.08",
            "summary": "Backend Engineer · platform and algorithm development; one of the leading members of the AIGC exploration initiative.",
            "focus": [],
            "progress": 100,
            "face": "(๑˃̵ᴗ˂̵)",
            "highlights": []
        },
        {
            "company": "MSRA",
            "period": "2021.12 – 2022.06",
            "summary": "Algorithm Researcher · Machine Learning Group, project-based; decision modeling and simulation for long-term carbon-policy planning.",
            "focus": [],
            "progress": 100,
            "face": "(✧ω✧)",
            "highlights": []
        },
        {
            "company": "DeepRoute.ai",
            "period": "2021.06 – 2021.12",
            "summary": "Software Engineer Intern · autonomous-driving behavior and path planning.",
            "focus": [],
            "progress": 100,
            "face": "^_^",
            "highlights": []
        }
    ],
    "contactTitle": "Contact Me",
    "contact": "ushouldknowr0@gmail.com",
    "technicalLeadershipTitle": "Technology Leadership",
    "technicalLeadershipIntro": "From business priorities to a system and team that can evolve.",
    "technicalResponsibilities": [
        {
            "title": "Technical strategy",
            "description": "Align the roadmap and investment with business priorities."
        },
        {
            "title": "Architecture & evolution",
            "description": "Set platform boundaries, reuse strategy, and paths for change."
        },
        {
            "title": "Engineering organization",
            "description": "Define ownership, develop people, and establish shared standards."
        },
        {
            "title": "Quality & cost governance",
            "description": "Set quality gates and balance reliability, risk, and operating cost."
        }
    ],
    "aboutPersonal": "Photographer · Calligrapher (Lingnan School)",
    "leadershipMandate": [
        "Set direction.",
        "Build the organization.",
        "Own the outcome."
    ],
    "leadershipDimensions": [
        {
            "id": "strategy",
            "label": "Strategy",
            "caption": "Choose the direction",
            "title": "Strategic judgment",
            "question": "Which future is worth building?",
            "description": "Translate business context and technology shifts into a product portfolio: what to pursue, what to defer, and what evidence justifies the next commitment."
        },
        {
            "id": "investment",
            "label": "Investment",
            "caption": "Commit resources wisely",
            "title": "Investment judgment",
            "question": "Where should the next investment go?",
            "description": "Weigh people, platform reuse, infrastructure, and external tools together. Allocate resources by strategic fit, expected value, and total cost."
        },
        {
            "id": "technology",
            "label": "Technology",
            "caption": "Build lasting capability",
            "title": "Technical direction",
            "question": "What capabilities should we own?",
            "description": "Set the direction across products, shared platforms, and core systems. Decide where technical depth creates an advantage and where reuse keeps the organization focused."
        },
        {
            "id": "organization",
            "label": "Organization",
            "caption": "Build collective strength",
            "title": "Organization building",
            "question": "How does the team become more capable?",
            "description": "Connect structure, ownership, and talent. Align product, engineering, data, and operations; develop people who can make sound decisions and carry responsibility."
        },
        {
            "id": "governance",
            "label": "Governance",
            "caption": "Define how decisions hold",
            "title": "Governance & risk",
            "question": "What must remain true as we grow?",
            "description": "Establish shared standards, clear decision responsibilities, quality gates, and risk boundaries. Make accountability and escalation part of how the organization operates."
        },
        {
            "id": "value",
            "label": "Value",
            "caption": "Answer for the result",
            "title": "Business accountability",
            "question": "What deserves to scale, change, or stop?",
            "description": "Evaluate success through adoption, quality, efficiency, and cost. Use the evidence to revisit priorities and decide which capabilities deserve continued investment."
        }
    ],
    "aboutMission": "Expand what people can create."
};

export const resumeDetailZh = {
    "subtitle": "AI 产研负责人 / 技术负责人：形成 Agent 工程方法，统筹业务方向、技术体系与团队交付。",
    "profileFactsTop": [
        "凌瀚远",
        "26 岁",
        "AI 产研负责人 / 技术负责人"
    ],
    "profileFactsBottom": [
        "业务方向与产品规划",
        "技术决策与组织统筹",
        "摄影师",
        "书法家（岭南画派）"
    ],
    "summaryRibbon": [
        {
            "id": "strategy",
            "title": "定义方向",
            "detail": "从业务全局判断机会，确定产品组合、投入重点与阶段目标。",
            "stack": "业务判断 / 产品战略"
        },
        {
            "id": "technology",
            "title": "统筹技术",
            "detail": "把握技术路线与架构边界，将关键研发沉淀为共用能力。",
            "stack": "技术决策 / 平台建设"
        },
        {
            "id": "organization",
            "title": "建设组织",
            "detail": "配置资源、发展人才，让跨职能团队对齐目标并承担责任。",
            "stack": "资源配置 / 人才发展"
        },
        {
            "id": "accountability",
            "title": "承担结果",
            "detail": "建立质量与风险治理，以业务使用和实际反馈检验投入。",
            "stack": "交付治理 / 业务价值"
        }
    ],
    "sectionTitles": {
        "stack": "技术与工程能力",
        "milestones": "经历与成果",
        "projects": "项目经历"
    },
    "scenes": [
        {
            "id": "boot",
            "points": [
                "腾讯 IEG（2022–2025）",
                "AI LAB / 数据团队（2025–至今）",
                "Aixera（2026.07–2026.09）"
            ]
        }
    ],
    "introExperiences": [
        {
            "company": "深圳市艾塞拉科技有限公司",
            "role": "项目技术负责人（项目合作，兼团队日常管理）",
            "period": "2026.07-2026.09",
            "points": [
                "作为Aixera 自然语言驱动的游戏生成系统的技术负责人，统筹技术路线、核心研发、交付质量与团队日常管理，将产品目标转化为研发优先级、阶段计划和验收标准。",
                "技术决策与架构：主导游戏生成 Agent 的技术路线与系统架构设计，明确模块职责、协作边界与阶段交付要求，结合生成质量、工程可控性及依赖成本推进方案取舍，并参与关键链路研发。",
                "研发交付与质量把关：牵头关键技术问题攻关，推动模型调用稳定性与异常处理；组织制定规则正确性、游戏可玩性及交互表现的验证标准，统筹回归测试与问题修复，依据运行与评测结果把关阶段交付。",
                "团队统筹与能力建设：统筹产品、研发、测试和运营协作，围绕 MVP 目标明确研发优先级、职责分工与交付边界，协调跨环节依赖并推进阻塞问题解决；通过方案评审与成员辅导，推动团队独立形成判断并承担交付责任。",
                "产品判断与成果沉淀：提出小范围产品验证路径，规划选题、制作、检查、试玩与反馈流程，以验证证据支撑产品方向和研发投入的阶段性取舍；推动技术方案与代表性成果归档，沉淀可复用的生成、评测与交付方法。"
            ],
            "id": "aixera",
            "iconKey": "",
            "iconFallback": "✦",
            "tags": [
                "技术路线与架构",
                "核心研发与质量把关",
                "团队日常管理",
                "跨职能协作",
                "阶段验证与交付"
            ],
            "links": [
                "gamefactory"
            ]
        },
        {
            "company": "广州拳游科技有限公司",
            "role": "AI LAB 部门负责人 / 数据开发团队负责人（合作）",
            "period": "2025.08-至今",
            "points": [
                "方向与产品规划：统筹 Fantasy 与全球站的 AI 应用、算法和数据建设，围绕支付运营、用户经营、研发效率及游戏创新筛选场景，确定优先级、技术路线与阶段投入，协调产品、研发、测试、运营和 HR 推进业务验收。",
                "部门建设与技术取舍：负责AI LAB 从零建设，将 Agent 方法转化为架构原则与评测规范，组织研究、工程和评估分工及共用能力建设。把 PR Agent 的研发重点放在跨仓关系与影响分析，优先复用已有执行内核，将自研投入集中于业务差异。",
                "业务数据与经营交付：牵头实时数仓、多平台支付成功率、失败归因和联运监控，推进转化预警与风控数据接入；统筹 VIP、Cashback、投放成本、用户标签及历史数据，组织会员冷启动、降级名单和奖励统计核验，推动会员服务上线与奖励规则线上验收。",
                "AI 产品与业务采用：主导智能问数与企业知识库产品化，支撑经营取数、主动预警和“敞亮人”新人赋能；推动日志诊断 Agent 及工具服务生产部署、本地化翻译工作台业务试用，以及Talent Mining 招聘评估产品交付与跨部门试用，依据业务反馈安排迭代。",
                "研发与内容提效：牵头产研一体 Agent、“QA 解放计划”试点，覆盖需求理解、代码审查和测试设计；组织项目知识管理、Figma 文案、PRD 与原型、游戏素材及风格工作台验证，覆盖多语言术语一致性、需求表达与创作准备。",
                "资源与创新投入：统一维护团队订阅、模型额度及服务资产，明确用途、费用、责任和续费周期；组织自然语言到可玩原型验证，形成覆盖模型、人力和基础设施的一年期投入测算，支持试点范围与资源评审，协调玩法、结算、配置及测试问题收敛。",
                "算法与工程把关：主导用户行为分群与受约束推荐策略，组织游戏数值算法设计、彩球抽奖及排行榜工程落地；围绕容量、指标口径与业务结果对账把关共用数据和算法服务。",
                "人才与研发体系：组织技术招聘、岗位评估、首月培养及方案辅导，推动成员独立判断并承担结果；通过 r0-skill 体系制定研发流程 SOP，明确分工、质量门禁与问题回流，统筹项目、里程碑、需求和风险管理。"
            ],
            "id": "ov",
            "iconKey": "openvision",
            "iconFallback": "✦",
            "tags": [
                "AI LAB 与数据团队统筹",
                "产品定义与技术路线",
                "支付与会员数据交付",
                "Agent 试点与平台建设",
                "招聘培养与上线核查"
            ],
            "links": [
                "query",
                "knowledge",
                "talent",
                "platform",
                "lattice",
                "bilm",
                "ovreco"
            ]
        },
        {
            "company": "深圳市腾讯计算机系统有限公司",
            "role": "IEG互动娱乐事业群，后台研发工程师",
            "period": "2022.07-2025.08",
            "points": [
                "独立研发团队内多个算法项目，如达人智选、达人Feed流推荐、内容风格聚类、内容风险识别和审查系统、基于相对定位的网格OCR识别算法，二游营收能力评估模型、社交网络驱动的多层评分挖掘策略、延迟队列系统等。",
                "2023 AIGC 中台业务探索专项领头成员之一，专项于2022年下旬启动，在早期即开始了对于LLM、LLM with RAG、LLM Chain、Stable-diffusion、CLIP、DragGAN&DragDiffusion、SAM、DINO、Fantasia3D等相关技术的业务落地探索，旨在探索 AIGC 游戏管线的建设方案及论证其合理性。参与项目：星瞳text2motion、星瞳LoRA训练&学车案例渲染管线、基于SAM的“金手指”标注工具、智能客服、基于CLIP的视频检索系统、LLM数据分析管线、Text2SQL模型微调（后成为部门内的“DataGather”工具基座）。",
                "负责“游可爱”项目后端开发，建设全链路多端KOL激励平台，涵盖KOL、内容、MCN、激励任务等多个子系统，支持任务维度与内容维度的全流程管理，覆盖多角色权限与流程管理模块。"
            ],
            "id": "tx",
            "iconKey": "tencent",
            "iconFallback": "✦",
            "tags": [
                "算法项目研发",
                "AIGC 中台探索专项领头成员之一",
                "推荐与内容审查",
                "游可爱 KOL 激励平台"
            ],
            "links": [
                "reco",
                "aipipe",
                "xingtong"
            ]
        },
        {
            "company": "微软亚洲研究院（MSRA）",
            "role": "Machine Learning组，算法研究员，项目制",
            "period": "2021.12-2022.06",
            "points": [
                "参与碳中和政策模拟项目，基于历史能耗、碳排放与经济数据，构建支持政府与企业长期规划的决策智能体系统，目标为模拟碳税、电价、科技投入等政策调控路径的动态反馈与最优解空间。"
            ],
            "id": "msra",
            "iconKey": "msra",
            "iconFallback": "✦",
            "tags": [
                "碳中和政策模拟",
                "强化学习决策智能体",
                "奖励塑形与因果推断"
            ],
            "links": [
                "carbon"
            ]
        },
        {
            "company": "深圳元戎启行科技有限公司",
            "role": "云计算/路径规划，软件开发工程师，实习",
            "period": "2021.06-2021.12",
            "points": [
                "参与 行为规划和路径规划 模块开发，负责编写转弯、变道等场景下的规则逻辑与行为决策逻辑。设计并落地无保护左转、交叉路口协同行驶、环岛通行逻辑、车道变换约束等行为规划规则，结合规则引擎驱动状态机生成可行路径候选。",
                "结合 HD 地图与感知数据（如 LIDAR、摄像头、雷达），定义车辆状态与环境特征输入，优化行为决策逻辑的执行效率与鲁棒性。落地采样与优化技术（A*、采样优化、轨迹优化），参考成本函数设计对路径候选进行排序与评估。"
            ],
            "id": "deeproute",
            "iconKey": "deeproute",
            "iconFallback": "✦",
            "tags": [
                "行为规划与路径规划",
                "规则引擎与状态机",
                "HD Map 与感知融合",
                "A* 与轨迹优化"
            ],
            "links": []
        }
    ],
    "introAchievements": [
        {
            "id": "query",
            "project": "智能问数 Agent：业务自助分析与 Lattice 数仓协同",
            "outcome": "10 个模板题端到端验收通过；高频标准题口径正确率 ≥90%；相关数据能力建设与成本优化每年节省至少 86 万元。",
            "note": "2026.08-至今 · 【关键词】业务语义、数据治理、智能分析、流程自动化、平台建设、成本优化",
            "labels": [
                "已交付"
            ],
            "catalogId": "query"
        },
        {
            "id": "gamefactory",
            "project": "Game Factory：自然语言驱动的游戏生成 Agent",
            "outcome": "完成自然语言需求到游戏生成、运行和交付的完整流程；覆盖真实模型生成、移动端交互与异常恢复验证。",
            "note": "2026.07-2026.09 · 【关键词】生成式 AI、游戏生成、多模态、数值控制、公平性验证、质量治理、运行安全",
            "labels": [
                "已交付"
            ],
            "catalogId": "gamefactory"
        },
        {
            "id": "knowledge",
            "project": "企业知识库：企业级知识服务与智能调查",
            "outcome": "已接入集团内部全部业务线；评测集覆盖 452 道题，答案正确性达 0.825。",
            "note": "2026.06-至今 · 【关键词】企业知识平台、RAG、业务语义、智能检索、Agentic 调查、权限治理、质量评测",
            "labels": [
                "已交付"
            ],
            "catalogId": "knowledge"
        },
        {
            "id": "talent",
            "project": "Talent Mining：人才评估与面试辅助 Agent",
            "outcome": "将岗位胜任力、行为访谈与职业心理维度用于前期评估和面试题生成；完成真实候选人链路验证，推进在线协作与跨部门试用。",
            "note": "2026.06-至今 · 【关键词】岗位胜任力、行为事件访谈、结构化面试、职业心理、测评设计、证据引用、人机协同",
            "labels": [
                "业务试用"
            ],
            "catalogId": "talent"
        },
        {
            "id": "platform",
            "project": "AI LAB 公共能力平台：Agent 工程与交付体系",
            "outcome": "沉淀语言工程、任务编排、偏好对齐三大范式；交付 ADK 阶段能力、研发 SOP、共用环境与团队知识资产。",
            "note": "2026.05-至今 · 【关键词】Agent 架构、语言工程、任务编排、偏好对齐、r0-skill、研发 SOP、公共能力平台",
            "labels": [
                "阶段交付"
            ],
            "catalogId": "platform"
        },
        {
            "id": "lattice",
            "project": "LatticeFlow 高速数仓：高性能实时数据平台",
            "outcome": "已具备约 3.3 万条/秒处理能力；承接约 1.78 亿条/日源事件；完成支付与获客转化监控交付。",
            "note": "2026.04-至今 · 【关键词】Rust、高性能计算、实时数仓、流式处理、数据一致性、容量治理、业务监控",
            "labels": [
                "生产交付"
            ],
            "catalogId": "lattice"
        },
        {
            "id": "bilm",
            "project": "BILM 高性能关系索引与持久化系统（Go）",
            "outcome": "在 largeID 3000 万 / smallID 500 级别规模下完成验证。",
            "note": "2025.11-2026.02 · 【关键词】RoaringBitmap、WAL、Snapshot、内存数据库",
            "labels": [
                "实现验证"
            ],
            "catalogId": "bilm"
        },
        {
            "id": "ovreco",
            "project": "全球站推荐：用户节奏感知的受约束收益优化推荐系统",
            "outcome": "以状态分群、多目标排序和显式风险约束组织推荐策略。",
            "note": "2025.09-至今 · 【关键词】用户分群、行为序列建模、多目标排序、风险感知推荐、生命周期约束、策略编排",
            "labels": [
                "技术方案"
            ],
            "catalogId": "global-recommendation"
        },
        {
            "id": "reco",
            "project": "达人智选：多链路召回与社交协同驱动的KOL智能推荐系统",
            "outcome": "召回命中率 ≥85%；Feed 点击率提升 23%；联合推荐覆盖超 30% 任务场景，接入超 20 个游戏项目组。",
            "note": "2024.06-2025.07 · 【关键词】多链路召回、双塔模型、相似度排序、圈层分发、内容聚类、Feed流、社交图、联合推荐",
            "labels": [
                "已交付"
            ],
            "catalogId": "kol"
        },
        {
            "id": "aipipe",
            "project": "自动化数据分析管线",
            "outcome": "推理成本下降逾 60%；改造版 NvBench 评估中召回率提升 10.7%，可替代初级分析师工时超 70%。",
            "note": "2023.03-2024.07 · 【关键词】LLM, ToolMaker, LATM, NvBench, Prompt Engineering, 数据安全",
            "labels": [
                "评测验证"
            ],
            "catalogId": "analytics"
        },
        {
            "id": "xingtong",
            "project": "星瞳 text2motion 动作生成系统",
            "outcome": "主流动作生成成功率 ≥80%；3 次直播 3D 回均实现 0 bug 运行。",
            "note": "2023.02-2024.07 · 【关键词】LLM, RAG, CLIP, MotionCLIP, Fantasia3D, SAM, 动作生成管线",
            "labels": [
                "场景验证"
            ],
            "catalogId": "motion"
        },
        {
            "id": "carbon",
            "project": "基于强化学习的碳中和政策模拟系统",
            "outcome": "模拟环境最优策略：碳排放下降 18%、社会成本降低 12%、策略波动性减少 21%；研讨接受度 7/8。",
            "note": "2022.02-2022.06 · 【关键词】强化学习、因果推断、政策优化、奖励函数设计、因果图",
            "labels": [
                "模拟研究"
            ],
            "catalogId": "carbon"
        }
    ],
    "capabilityTracks": [
        {
            "id": "algoData",
            "name": "数据战略与经营决策",
            "summary": "以数据建设连接业务判断、资源投入与经营价值。",
            "details": [
                "经营视角：从业务全局确定数据建设重点，连接经营分析、用户增长与风险治理。",
                "资产布局：统筹数据平台与业务应用，确定共用能力、专项投入及演进路线。",
                "组织协同：对齐业务、产品与数据团队的目标和责任，形成统一指标与交付标准。",
                "价值管理：以业务采用、决策效率和投入产出评估建设成效，驱动持续优化。"
            ],
            "terms": [
                "Golang",
                "Kafka",
                "MySQL",
                "Flink",
                "StarRocks",
                "Paimon",
                "PostgreSQL",
                "RoaringBitmap",
                "WAL",
                "Rust",
                "Arrow"
            ],
            "value": null
        },
        {
            "id": "fullstack",
            "name": "技术战略与工程组织",
            "summary": "统筹技术路线、平台演进与团队持续交付能力。",
            "details": [
                "战略取舍：统筹产品路线与技术投入，权衡自建、采购、复用与长期维护成本。",
                "架构演进：规划系统边界与平台能力，使业务增长、系统复杂度与可靠性协同演进。",
                "组织建设：明确责任分工与协作机制，通过招聘、培养和评审建设持续交付的团队。",
                "交付治理：建立贯穿需求、研发与上线的质量标准，对交付、风险和运行成本承担责任。"
            ],
            "terms": [
                "Rust",
                "Golang",
                "PostgreSQL",
                "TypeScript",
                "React",
                "Node.js",
                "gRPC",
                "WebSocket",
                "Docker",
                "Kubernetes",
                "Redis",
                "RoaringBitmap",
                "WAL"
            ],
            "value": null
        },
        {
            "id": "llm",
            "name": "AI 产品战略与知识体系",
            "summary": "把技术机会转化为产品布局与可复用的组织能力。",
            "details": [
                "机会判断：识别 AI 能改变业务方式的关键环节，明确产品价值、优先级与投入边界。",
                "产品布局：统筹研发、运营与组织协作等应用方向，规划试点路径、共用能力与演进节奏。",
                "能力建设：围绕知识、工具与人才建设共用平台，将团队经验转化为可复用的组织能力。",
                "应用治理：统筹使用边界、评价标准和业务反馈，推动技术能力转化为持续可用的业务服务。"
            ],
            "terms": [
                "Python3",
                "Rust",
                "Agent Harness",
                "RAGFlow",
                "RAG",
                "OpenSearch",
                "Qdrant",
                "Weighted RRF",
                "BGE",
                "LangChain",
                "LlamaIndex",
                "MCP-Agent",
                "CLIP",
                "MotionCLIP",
                "PyTorch"
            ],
            "value": null
        },
        {
            "id": "reco",
            "name": "算法战略与决策体系",
            "summary": "在增长、体验与风险之间建立可持续的决策机制。",
            "details": [
                "目标建模：将增长、收益、体验与风险转为统一决策目标，明确优先级和约束。",
                "方案取舍：统筹算法、产品与业务判断，在效果、解释性、成本和长期价值之间取舍。",
                "评价体系：建立从研究验证、实验评估到业务验收的评价机制，为投入和迭代提供依据。",
                "治理闭环：将公平性、可控性与反馈复盘纳入决策机制，确保策略演进服务业务目标。"
            ],
            "terms": [
                "Python3",
                "C++",
                "PyTorch",
                "K-Means",
                "GMM",
                "DQN",
                "PPO",
                "Causal Inference",
                "CLIP"
            ],
            "value": null
        }
    ],
    "resumeDomains": [
        {
            "id": "leadership",
            "title": "技术统筹与研发交付",
            "points": [
                "从业务全局确定产品组合、技术投入与阶段目标",
                "沉淀语言工程、任务编排、偏好对齐三大范式，指导平台与应用架构",
                "通过 r0-skill 制定研发 SOP，建立质量门禁、问题回流与团队协作机制"
            ]
        },
        {
            "id": "agent-engineering",
            "title": "Agent 架构与知识工程",
            "category": "方法与技术判断",
            "points": [
                "语言工程：治理来源、时效、上下文与读写边界",
                "本体与语义建模：统一业务对象、类型、关系和约束，区分事实与规则",
                "知识编译与证据检索：消歧、冲突治理、版本管理与可追溯上下文",
                "任务编排与偏好对齐：按状态与风险设计执行方式，以评审和反馈持续改进"
            ]
        },
        {
            "id": "patent",
            "category": "知识产权",
            "title": "专利申请 · 交互式智能图像标注",
            "points": [
                "《图像标注方法、装置、设备及介质》；发明专利申请已公开",
                "唯一发明人：凌瀚远；申请人：腾讯科技（深圳）有限公司",
                "申请号 202311199516.9；申请公布号 CN 117036713 A；申请日 2023.09.15"
            ]
        },
        {
            "id": "copyright",
            "category": "知识产权",
            "title": "软件著作权 · 物联网控制系统",
            "points": [
                "基于机器学习的物联网控制系统；独立著作权人",
                "登记号 2020SR0568084；2020.04",
                "融合多源传感数据与时序预测，实现环境监测、联动控制及告警"
            ]
        },
        {
            "id": "languages",
            "category": "语言",
            "title": "交流语言",
            "points": [
                "粤语、普通话、日语、英语"
            ]
        }
    ],
    "projectHighlights": projectCatalog,
    "wins": [
        {
            "id": "ccpc-changchun",
            "label": "CCPC 长春站（2020）",
            "medal": "铜牌",
            "emoji": "🥉",
            "color": "#cd7f32"
        },
        {
            "id": "ccpc-weihai",
            "label": "CCPC 威海站（2020）",
            "medal": "铜牌",
            "emoji": "🥉",
            "color": "#b87333"
        },
        {
            "id": "icpc-shanghai",
            "label": "ICPC 上海站（2020）",
            "medal": "铁牌",
            "emoji": "⚙️",
            "color": "#7f8c8d"
        },
        {
            "id": "icpc-jinan",
            "label": "ICPC 济南站（2020）",
            "medal": "银牌",
            "emoji": "🥈",
            "color": "#c0c0c0"
        }
    ]
};
